import {createContext} from 'react';
import {
    IProductSnippetAnalytics,
    IProductStoreEventContext,
    IProductTrackingHandlers,
} from 'modules/analytics/types/ProductSnippetAnalytics';

interface IGetTrackingHandlersParams {
    productAnalytics: IProductSnippetAnalytics;
    productUrl: string;
    category: {id?: number; name?: string};
    storeEventContext: IProductStoreEventContext;
}

export interface IProductSnippetContextProps {
    getTrackingHandlers: (params: IGetTrackingHandlersParams) => IProductTrackingHandlers;
}

export const ProductSnippetAnalyticsContext = createContext<IProductSnippetContextProps>({
    getTrackingHandlers: () => {
        return {
            onProductView: () => {},
            onProductClick: () => {},
            onReviewsClick: () => {},
            onStockClick: () => {},
            onCatalogClick: () => {},
            onAddToCartClick: () => {},
            onRemoveFromCartClick: () => {},
            onAddToWishlistClick: () => {},
            onRemoveFromWishlistClick: () => {},
        };
    },
});
